import { createStore, IModuleStore } from 'redux-dynamic-modules';
import { applyMiddleware } from 'redux';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'connected-react-router';
import { ActionType } from 'typesafe-actions';

import { configureTrackJs } from 'common/services/ErrorReporting';
import historyService from 'common/services/HistoryService';
import { getUrlParam } from 'common/util/url/urlUtil';

import { StoreManager as CommonStoreManager } from 'common/store/typings';
import { getRootModule } from './rootModule';
import { RootState } from './rootReducer';

const dispatchLogger = getUrlParam('dispatchLogger');

const middleware = [routerMiddleware(historyService.getHistory())];

if (dispatchLogger) {
    middleware.push(createLogger());
}

interface StoreManager extends CommonStoreManager {
    store: IModuleStore<RootState>;
    createStore: (initialState?: any) => IModuleStore<RootState>;
    dispatch: (action: ActionType<any>) => void;
    getState: () => RootState;
    getStore: () => IModuleStore<RootState>;
}

const storeManager: StoreManager = {
    store: undefined,

    createStore(initialState: any = {}) {
        storeManager.store = createStore(
            {
                initialState,
                extensions: [getSagaExtension({} /* saga context */)],
                enhancers: [applyMiddleware(...middleware)],
            },
            getRootModule(),
            /* ...any additional modules */
        );

        return storeManager.store;
    },

    dispatch(action: ActionType<any>) {
        return storeManager.store.dispatch(action);
    },

    getStore() {
        return storeManager.store;
    },

    getState() {
        return storeManager.store.getState();
    },
};

if (configureTrackJs) {
    configureTrackJs(window.userId);
}


export default storeManager;
